export default {
  // 接口地址
  baseURL: 'https://www.wellsoon.cn/index/',
  isDev: true
}



// WEBPACK FOOTER //
// ./src/api/env.js